/**
 * @return  ['phase-rules']
 * */
export const phaseRulesKey = () => ["phase-rules"];

/**
 * @param   {object} { campaignId }
 * @return  ['phase-rules', { campaignId: number }]
 * */
export const phaseRulesWithCampaignId = ({ campaignId }) => [...phaseRulesKey(), { campaignId }];
